export enum FieldsEnum {
  email = 'email',
  password = 'password',
}
